export type InfoScreenEvent = {
  id: string;
  source: string;
  title: string;
  starts_at: string;
  ends_at?: string | null;
  time_label?: string | null;
  venue_name?: string | null;
  city?: string | null;
  category?: string | null;
  description?: string | null;
  image_url?: string | null;
  event_url?: string | null;
  priority: number;
};

export type InfoScreenEventCatalogItem = InfoScreenEvent & {
  is_visible: boolean;
};

export type InfoScreenEventsPayload = {
  enabled: boolean;
  city_label: string;
  events: InfoScreenEvent[];
  rotation_seconds: number;
  modules: InfoScreenModule[];
};

export type InfoScreenModule = {
  id: string;
  type: "pages" | "local_events";
  enabled: boolean;
  sort_order: number;
};

export type InfoScreenEventsConfig = {
  events: Record<string, unknown>;
  modules: InfoScreenModule[];
  secrets_status: {
    eventbrite_configured: boolean;
    eventbrite_masked?: string | null;
    eventbrite_organization_id?: string | null;
    ticketmaster_configured: boolean;
    ticketmaster_masked?: string | null;
  };
};

export type InfoScreenManualEvent = {
  id: string;
  title: string;
  starts_at: string;
  ends_at?: string | null;
  time_label?: string | null;
  venue_name?: string | null;
  city?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  category?: string | null;
  description?: string | null;
  image_url?: string | null;
  event_url?: string | null;
  priority: number;
  is_active: boolean;
  archived_at?: string | null;
  created_at: string;
  updated_at: string;
};

export const EVENT_CATEGORIES = [
  { id: "music", label: "Musik" },
  { id: "culture", label: "Kultur" },
  { id: "sport", label: "Sport" },
  { id: "family", label: "Familie" },
  { id: "food", label: "Gastronomie" },
  { id: "market", label: "Markt & Messe" },
  { id: "nightlife", label: "Nachtleben" },
  { id: "other", label: "Sonstiges" },
] as const;

export type InfoScreenSyncProviderStatus = {
  success: boolean;
  count: number;
  error?: string | null;
};

export type InfoScreenSyncResult = {
  success: boolean;
  synced_events: number;
  providers: Record<string, InfoScreenSyncProviderStatus>;
  results?: Array<{
    provider: string;
    status: string;
    events_fetched: number;
    events_upserted: number;
    error_message?: string | null;
  }>;
};

export type EventbriteTestResult = {
  success: boolean;
  status_code?: number | null;
  message: string;
  authorization_header_present: boolean;
  events_found: number;
};

export const EVENT_TIME_RANGES = [
  { id: "today", label: "Heute" },
  { id: "this_weekend", label: "Nächstes Wochenende" },
  { id: "next_7_days", label: "Nächste 7 Tage" },
  { id: "next_14_days", label: "Nächste 14 Tage" },
] as const;
